export default __webpack_public_path__ + "static/media/blue-background.7deecdd1.jpg";